/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileFormatJpgIcon16Light } from './FileFormatJpgIcon16Light';
import { FileFormatJpgIcon16Regular } from './FileFormatJpgIcon16Regular';
import { FileFormatJpgIcon16Solid } from './FileFormatJpgIcon16Solid';
import { FileFormatJpgIcon20Light } from './FileFormatJpgIcon20Light';
import { FileFormatJpgIcon20Regular } from './FileFormatJpgIcon20Regular';
import { FileFormatJpgIcon20Solid } from './FileFormatJpgIcon20Solid';
import { FileFormatJpgIcon24Regular } from './FileFormatJpgIcon24Regular';
import { FileFormatJpgIcon24Solid } from './FileFormatJpgIcon24Solid';
import { FileFormatJpgIcon32Regular } from './FileFormatJpgIcon32Regular';
import { FileFormatJpgIcon64Regular } from './FileFormatJpgIcon64Regular';
var sizes = {
    16: {
        light: FileFormatJpgIcon16Light,
        regular: FileFormatJpgIcon16Regular,
        solid: FileFormatJpgIcon16Solid,
    },
    20: {
        light: FileFormatJpgIcon20Light,
        regular: FileFormatJpgIcon20Regular,
        solid: FileFormatJpgIcon20Solid,
    },
    24: {
        regular: FileFormatJpgIcon24Regular,
        solid: FileFormatJpgIcon24Solid,
    },
    32: {
        regular: FileFormatJpgIcon32Regular,
    },
    64: {
        regular: FileFormatJpgIcon64Regular,
    },
};
export var FileFormatJpgIcon = forwardRef('FileFormatJpgIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
